import { RuleObject } from "antd/es/form";
import { DOMAIN_REGEX, EMAIL_REGEX, PHONE_REGEX } from "../../../../../../../../constants/regexConstants";
import { CreateDownlineRequestFields, FormItemType } from "../../../../createDownline.constants";
import { FormItem, SelectedProductCommission } from "../../../../createDownline.models";
import { formatPhoneInputValue, formatSubdomainInputValue } from "../../../../../../../../utils/inputUtils";

export const getFormRules = (item: FormItem) => {
    const requiredMessage = `${item.label} is required`;

    if (item.field === CreateDownlineRequestFields.WRITING_NUMBER) {
        return [
            { required: true, message: requiredMessage },
            { pattern: /^\S+$/, message: "Please enter a valid value" },
        ];
    }

    if (item.field === CreateDownlineRequestFields.AGENCY_NUMBER) {
        return [{ pattern: /^\S+$/, message: "Please enter a valid value" }];
    }

    if (item.type === FormItemType.EMAIL) {
        return [
            { required: true, message: requiredMessage },
            { pattern: EMAIL_REGEX, message: "Please enter a valid email" },
        ];
    }

    if (item.type === FormItemType.URL) {
        return [{ pattern: DOMAIN_REGEX, message: "Please enter a valid Subdomain" }];
    }

    if (item.type === FormItemType.TEL) {
        return [
            {
                pattern: PHONE_REGEX,
                message: "Please enter a valid phone number",
            },
        ];
    }

    if (item.field === CreateDownlineRequestFields.AGENCY_NAME) {
        return [{ required: false }];
    }

    return [{ required: true, message: requiredMessage }];
};

export const getProductGroupRules = () => [
    {
        validator: (_: RuleObject, value: SelectedProductCommission[] | undefined) => {
            if (value?.length) {
                return Promise.resolve();
            }
            return Promise.reject(new Error("Please add at least one product and commission level"));
        },
    },
];

export const getInputValueFromEvent = (type: FormItemType) => {
    if (type === FormItemType.TEL) {
        return (event: { target?: { value?: string } }) =>
            formatPhoneInputValue(event?.target?.value ?? "");
    }
    if (type === FormItemType.URL) {
        return (event: { target?: { value?: string } }) =>
            formatSubdomainInputValue(event?.target?.value ?? "");
    }
    return undefined;
};